import Header from "../../../layouts/header/Header";
import Footer from "../../../layouts/footer/Footer";
import BasicIconCard from "./BasicIconCard";
import GreenCheckIcon from "../../../icons/GreenCheckIcon";
import PYPFormsContainer from "./PYPFormsContainer";
export const PYPHomepage = () => {
  return (
    <>
      <Header />
      <div className="px-customPaddingMobile lg:px-customPadding 2xl:mx-auto 2xl:w-[1340px] 2xl:px-0 mt-4 lg:mt-8 mid:flex mid:justify-between">
        <div className="flex-1">
          <p className="mid:max-w-[534px] uppercase font-spaceGrotesk font-normal text-mobile-h1 md:text-[44px] leading-10 md:leading-[56px] text-brand-bgBlack">
            Upload your property in simple steps
          </p>
          <div className="flex space-x-3 md:space-x-5 mt-2 lg:mt-6">
            <BasicIconCard
              message="Add Basic Details"
              icon={<GreenCheckIcon className="h-3 w-3 md:h-auto md:w-auto" />}
            />
            <BasicIconCard
              message="Add Property Details"
              icon={<GreenCheckIcon className="h-3 w-3 md:h-auto md:w-auto" />}
            />
          </div>
          <img
            src="./postYourPropertyHome.png"
            className="mt-12 lg:mt-7 lg:min-w-[470px] object-contain "
            alt=""
          />
        </div>
        <PYPFormsContainer className=" mid:ml-12 mid:mt-4" />
      </div>
      <Footer />
    </>
  );
};

export default PYPHomepage;
